import React from 'react'
import {useGameState} from '../../hooks/useGameState'
import Drawing from './Drawing'

export default function Progress() {
  const {tries, isLost} = useGameState()

  if (isLost) {
    return <>
      <Drawing/>
      <h1>Oh no!</h1>
    </>
  }

  if (tries.length) {
    return <>
      <Drawing/>
      <h1>&nbsp;</h1>
    </>
  }

  return <>
    <Drawing/>
    <h1>Try a letter...</h1>
  </>
}

